/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useState } from 'react';

import { ClassNameMap } from '@mui/material/styles';

import { FilePreview } from '@vk-hr-tek/ui/FilePreview';
import { useInject } from '@vk-hr-tek/core/ioc';
import { Box } from '@vk-hr-tek/ui/Box';

import { useRole } from '@app/hooks';

import { LayoutService } from '../../services';

import { LogoEmptyIcon } from './LogoEmptyIcon';
import { useStyles } from './CandidatePageLogo.styles';
import { LogoEmptyIconText } from './LogoEmptyIconText';

type LogoIconVariants = '24' | '56';

interface CandidatePageLogoProps {
  candidateEventId: string | null;
  variant?: LogoIconVariants;
}

const getSizeClass = (variant: LogoIconVariants, classes: ClassNameMap) => {
  switch (variant) {
    case '24':
      return classes.icon24;
    case '56':
      return classes.icon56;
    default:
      return classes.icon56;
  }
};

export const CandidatePageLogo = ({
  candidateEventId,
  variant = '56',
}: CandidatePageLogoProps) => {
  const { classes } = useStyles();
  const [role] = useRole();
  const layout = useInject(LayoutService);

  const [error, setError] = useState<Error>();

  const loadDocument = useCallback(
    (id: string) => async () => {
      const res = await layout.getCandidateLogo(id);

      return res.file;
    },
    [role],
  );

  const sizeClass = getSizeClass(variant, classes);

  useEffect(() => {
    setError(undefined);
  }, [role]);

  if (error || candidateEventId === null) {
    return (
      <Box className={classes.errorLogo}>
        <LogoEmptyIcon />

        <Box display="flex" alignItems="center">
          <LogoEmptyIconText />
        </Box>
      </Box>
    );
  }

  return (
    <Box className={sizeClass}>
      <FilePreview
        onLoad={loadDocument(candidateEventId)}
        hideLoader
        onError={setError}
      />
    </Box>
  );
};
